"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Input_1 = __importDefault(require("../../../Input"));
const clsx_1 = __importDefault(require("clsx"));
const use_debounce_1 = require("use-debounce");
const ContainerHeaderContent = ({ loading, setGlobalFilter = () => { }, styles, disableFilters, globalFilter, settingsBarComponent, }) => {
    const handleChange = use_debounce_1.useDebouncedCallback((value) => {
        setGlobalFilter(value || undefined);
    }, 500);
    return (react_1.default.createElement("div", { className: styles.tableBar },
        !disableFilters && (react_1.default.createElement("div", { className: styles.searchBar },
            react_1.default.createElement("div", { id: "table-search-label", hidden: true }, "Search input to filter table items"),
            react_1.default.createElement(Input_1.default, { placeholder: "Search", type: "search", onChange: handleChange, disabled: loading, value: globalFilter, ariaLabelledby: "table-search-label" }),
            loading ? (react_1.default.createElement("div", { className: clsx_1.default(styles.cellAlign, styles.loadingSearchBarPadding) },
                react_1.default.createElement(core_1.CircularProgress, { color: "secondary", size: 12, variant: "indeterminate" }))) : null)),
        settingsBarComponent));
};
exports.default = ContainerHeaderContent;
//# sourceMappingURL=index.js.map